import { render, staticRenderFns } from "./poster-editor.vue?vue&type=template&id=46f24ca8&scoped=true&"
import script from "./poster-editor.vue?vue&type=script&lang=js&"
export * from "./poster-editor.vue?vue&type=script&lang=js&"
import style0 from "./poster-editor.vue?vue&type=style&index=0&id=46f24ca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f24ca8",
  null
  
)

export default component.exports